<template>
  <div class="droplayer icon filter-box todo relative">
    <!-- <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="sel"
          @click="$event.target.parentElement.classList.toggle('active')"
          @mouseup="filterBoxTodoListUser()"
          >필터</v-btn
        >
      </template>
      <div class="dropdown-list cnt board">
        <div class="cnt_inner clear">
          <div class="cnt-space">
            <div class="tit">공간</div>
            <ul>
              <li :class="space == '' ? 'active' : ''">
                <button type="button" @click="spaceSelect('')">전체</button>
              </li>
              <li :class="space == 'PRO' ? 'active' : ''">
                <button type="button" @click="spaceSelect('PRO')">

                </button>
              </li>
              <li :class="space == 'USER' ? 'active' : ''">
                <button type="button" @click="spaceSelect('USER')">
                  프라이빗
                </button>
              </li>
              <li :class="space == 'CFRC' ? 'active' : ''">
                <button type="button" @click="spaceSelect('CFRC')">
                  회의/협의
                </button>
              </li>
            </ul>
          </div>
          <div class="cnt-category">
            <div class="tit">/카테고리</div>
            <div class="nodata" v-if="space == ''">
              <div class="txt">공간을 선택해주세요.</div>
            </div>
            <ul v-if="space != ''">
              <template v-if="space == 'PRO'">
                <li :class="categoryIdList.length == 0 ? 'active' : ''">
                  <button type="button" @click="getProBoardList('')">
                    전체
                  </button>
                </li>
                <li
                  v-for="(item, index) in proList"
                  :key="'item_' + index"
                  :transfer-data="item"
                  :id="'proList_' + item.groupId"
                  :class="categoryActive(item.groupId, 'PRO') ? 'active' : ''"
                >
                  <button type="button" @click="getProBoardList(item)">
                    {{ item.projectName }}
                  </button>
                </li>
              </template>
              <template v-else-if="space == 'USER'">
                <li :class="categoryIdList.length == 0 ? 'active' : ''">
                  <button type="button" @click="getPrivBoardList('')">
                    전체
                  </button>
                </li>
                <li
                  v-for="(item, index) in privList"
                  :key="'item_' + index"
                  :transfer-data="item"
                  :id="'privList_' + item.categoryMid"
                  :class="
                    categoryActive(item.categoryMid, 'USER') ? 'active' : ''
                  "
                >
                  <button type="button" @click="getPrivBoardList(item)">
                    {{ item.categoryName }}
                  </button>
                </li>
              </template>
              <template v-else-if="space == 'CFRC'">
                <li :class="categoryIdList.length == 0 ? 'active' : ''">
                  <button type="button" @click="getCfrcBoardList('')">
                    전체
                  </button>
                </li>
                <li
                  v-for="(item, index) in cfrcList"
                  :key="'item_' + index"
                  :transfer-data="item"
                  :id="'cfrcList_' + item.categoryMid"
                  :class="
                    categoryActive(item.categoryMid, 'CFRC') ? 'active' : ''
                  "
                >
                  <button type="button" @click="getCfrcBoardList(item)">
                    {{ item.categoryName }}
                  </button>
                </li>
              </template>
            </ul>
          </div>
          <div class="cnt-category">
            <div class="tit">보드</div>
            <div class="nodata" v-if="proBoard.length == 0">
              <div class="txt">
                /카테고리를<br />
                선택해주세요.
              </div>
            </div>
            <ul v-if="proBoard.length > 0">
              <li :class="boardIdList.length == 0 ? 'active' : ''">
                <button type="button" @click="setBoardIdList('')">전체</button>
              </li>
              <li
                v-for="(item, index) in proBoard"
                :key="'item_' + index"
                :transfer-data="item"
                :id="'proBoard_' + item.paperId"
                :class="boardActive(item.paperId) ? 'active' : ''"
              >
                <button type="button" @click="setBoardIdList(item)">
                  {{ item.paperTitle }}
                </button>
              </li>
            </ul>
          </div>
          <div class="cnt-editor" v-if="filterInfo === 'fromMe'">
            <div class="tit">담당자</div>
            <ul>
              <li>
                <input type="checkbox" id="all2" v-model="allSelected" />
                <label for="all2" @click="setTargetUser('')">전체</label>
              </li>
              <li
                v-for="(char, index) in charger"
                :key="'charger_' + index"
                :transfer-data="char"
              >
                <input
                  type="checkbox"
                  :id="'charger_' + char.userId"
                  :value="char.userId"
                  v-model="targetUser"
                  @click="setTargetUser(char.userId)"
                />
                <label :for="'charger_' + char.userId">
                  {{ char.userName }}
                </label>
              </li>
            </ul>
          </div>
          <div class="cnt-editor" v-if="filterInfo === 'toMe'">
            <div class="tit">작성자</div>
            <ul>
              <li>
                <input type="checkbox" id="all2" v-model="allSelected" />
                <label for="all2" @click="setTargetRegUser('')">전체</label>
              </li>
              <li
                v-for="(char, index) in regUser"
                :key="'regUser_' + index"
                :transfer-data="char"
              >
                <input
                  type="checkbox"
                  :id="'regUser_' + char.userId"
                  :value="char.userId"
                  v-model="targetRegUser"
                  @click="setTargetRegUser(char.userId)"
                />
                <label :for="'regUser_' + char.userId">
                  {{ char.userName }}
                </label>
              </li>
            </ul>
          </div>
          <div class="cnt-progress">
            <div class="tit">진행 상태</div>
            <ul>
              <li :class="status == 0 ? 'active' : ''">
                <button type="button" class="all" @click="status = 0">
                  진행상태전체
                </button>
              </li>
              <li :class="status == 1 ? 'active' : ''">
                <button
                  type="button"
                  class="ico-txt-status-ongoing"
                  @click="status = 1"
                >
                  미완료
                </button>
              </li>
              <li :class="status == 2 ? 'active' : ''">
                <button
                  type="button"
                  class="ico-txt-status-completion"
                  @click="status = 2"
                >
                  완료
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="info">필터는 중복 선택이 가능합니다.</div>
      </div>
    </v-menu> -->
  </div>
</template>

<script>
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    startDate: Date,
    endDate: Date,
    filterInfo: String
  },
  data() {
    return {
      show: false,
      // 1.담당자 리스트 [{id, name}]
      charger: [],
      regUser: [],
      targetUser: [],
      targetRegUser: [],

      boardIdList: [],
      // 2. 연결보드 리스트 [{papid, paptit, proid}]
      proBoard: [],

      // 3. 프라이빗 연결보드 리스트 [{papid, paptit, catId}]
      privBoard: [],

      // 4. 회/협 연결보드 리스트 [{papid, paptit, catId}]
      cfrcBoard: [],

      // 5.  리스트 [{proid, proname, groupid}]
      proList: [],
      categoryIdList: [],

      // 6. 프라이빗 카테고리 [{catId, catname}]
      privList: [],

      // 7. 회/협 카테고리 [{catId, catname}]
      cfrcList: [],

      status: 0,

      space: "",
      privGroupInfo: null,
      privGroupId: null,
      privGroupName: null,

      allSelected: false
    };
  },
  created() {
    EventBus.$on("refreshFilterBoxTodo", payload => {
      this.spaceSelect("");
    });
  },
  mounted() {},
  updated() {
    EventBus.$emit("FilterBoxTodoSetSpace", this.space); // 공간
    EventBus.$emit("FilterBoxTodoSetCategory", this.categoryIdList); // 카테고리
    EventBus.$emit("FilterBoxTodoSetBoard", this.boardIdList); // 보드
    EventBus.$emit("FilterBoxTodoSetTargetUser", this.targetUser); // 담당자
    EventBus.$emit("FilterBoxTodoSetTargetRegUser", this.targetRegUser); // 담당자
    EventBus.$emit("FilterBoxTodoSetStatus", this.status); // 진행상태
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    filterBoxTodoListUser() {
      EventBus.$emit("FilterBoxTodoSetLinkIdList", "");
      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;
      let reqData = {};

      let rawCharger = null;
      let rawRegUser = null;
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        toData: to,
        fromdata: from
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getFilterListUser";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        rawCharger = response.result.Charger;
        rawRegUser = response.result.RegUser;
        obj.charger = rawCharger;
        obj.regUser = rawRegUser;
      });
      this.initPrivGorupId();
    },
    filterBoxTodoListProList() {
      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD")
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getFilterListPro";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        this.proList = response.result;
      });
    },
    filterBoxTodoListPrivList() {
      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        privGroupId: obj.privGroupId
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getFilterListPriv";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        this.privList = response.result;
      });
    },
    filterBoxTodoListCfrcList() {
      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD")
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getFilterListCfrc";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        this.cfrcList = response.result;
      });
    },

    getProBoardList(param) {
      if (param === "") {
        this.categoryReset();
      } else if (this.categoryIdList.length > 0) {
        let paramChk = true;
        for (let i = 0; i < this.categoryIdList.length; i++) {
          if (this.categoryIdList[i] === param.groupId) {
            this.categoryIdList.splice(i, 1);
            paramChk = false;
            document
              .getElementById("proList_" + param.groupId)
              .classList.remove("active");
          }
        }
        if (paramChk) {
          this.categoryIdList.push(param.groupId);
          document
            .getElementById("proList_" + param.groupId)
            .classList.add("active");
        }
      } else {
        this.categoryIdList.push(param.groupId);
        document
          .getElementById("proList_" + param.groupId)
          .classList.add("active");
      }
      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;

      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        paperId: this.categoryIdList
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getProBoardList";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        this.proBoard = response.result;
      });
    },
    getPrivBoardList(param) {
      if (param === "") {
        this.categoryReset();
      } else if (this.categoryIdList.length > 0) {
        let paramChk = true;
        for (let i = 0; i < this.categoryIdList.length; i++) {
          if (this.categoryIdList[i] === param.categoryMid) {
            this.categoryIdList.splice(i, 1);
            paramChk = false;
          }
        }
        if (paramChk) {
          this.categoryIdList.push(param.categoryMid);
        }
      } else {
        this.categoryIdList.push(param.categoryMid);
      }
      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        categoryId: this.categoryIdList,
        privGroupId: this.privGroupId
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getPrivBoardList";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        this.proBoard = response.result;
      });
    },
    getCfrcBoardList(param) {
      if (param === "") {
        this.categoryReset();
      } else if (this.categoryIdList.length > 0) {
        let paramChk = true;
        for (let i = 0; i < this.categoryIdList.length; i++) {
          if (this.categoryIdList[i] === param.categoryMid) {
            this.categoryIdList.splice(i, 1);
            paramChk = false;
          }
        }
        if (paramChk) {
          this.categoryIdList.push(param.categoryMid);
        }
      } else {
        this.categoryIdList.push(param.categoryMid);
      }

      let to = this.listToData;
      let from = this.listFromData;
      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        categoryId: this.categoryIdList
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/todo/getCfrcBoardList";
      reqData.method = "post";
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then(response => {
        // this.cfrcBoard = response.result;
        // console.log(reqData.params.categoryMid);
        this.proBoard = response.result;
      });
    },

    setBoardIdList(param) {
      if (param === "") {
        this.boardReset();
      } else if (this.boardIdList.length > 0) {
        let paramChk = true;
        for (let i = 0; i < this.boardIdList.length; i++) {
          if (this.boardIdList[i] === param.paperId) {
            this.boardIdList.splice(i, 1);
            paramChk = false;
          }
        }
        if (paramChk) {
          this.boardIdList.push(param.paperId);
        }
      } else {
        this.boardIdList.push(param.paperId);
      }
    },
    setTargetUser(param) {
      if (param === "") {
        this.userReset();
      } else if (this.targetUser.length > 0) {
        let paramChk = true;
        for (let i = 0; i < this.targetUser.length; i++) {
          if (this.targetUser[i] === param) {
            this.targetUser.splice(i, 1);
            paramChk = false;
          }
        }
        if (paramChk) {
          this.targetUser.push(param);
          this.allSelected = false;
        }
      } else {
        this.targetUser.push(param);
        this.allSelected = false;
      }
      EventBus.$emit("FilterBoxTodoSetTargetUser", this.targetUser); // 담당자
    },

    setTargetRegUser(param) {
      if (param === "") {
        this.userReset();
      } else if (this.targetRegUser.length > 0) {
        let paramChk = true;
        for (let i = 0; i < this.targetRegUser.length; i++) {
          if (this.targetRegUser[i] === param) {
            this.targetRegUser.splice(i, 1);
            paramChk = false;
          }
        }
        if (paramChk) {
          this.targetRegUser.push(param);
          this.allSelected = false;
        }
      } else {
        this.targetRegUser.push(param);
        this.allSelected = false;
      }
      EventBus.$emit("FilterBoxTodoSetTargetRegUser", this.targetRegUser); // 담당자
    },

    // this.proBoard = response.data.proBoard;
    // this.privBoard = response.data.privBoard;
    // this.cfrcBoard = response.data.cfrcBoard;

    spaceSelect(param) {
      this.space = param;
      this.categoryReset();
      if (param === "PRO") {
        this.filterBoxTodoListProList();
      } else if (param === "USER") {
        this.filterBoxTodoListPrivList();
      } else if (param === "CFRC") {
        this.filterBoxTodoListCfrcList();
      }
    },
    categoryReset(param) {
      // if (param === "PRO") {
      //   for (let i = 0; i < this.proList.length; i++) {
      //     document
      //       .getElementById("proList_" + this.proList[i].groupId)
      //       .classList.remove("active");
      //   }
      //   this.proBoardIdList = [];
      // } else if (param === "PRIV") {
      //   for (let i = 0; i < this.privList.length; i++) {
      //     document
      //       .getElementById("privList_" + this.privList[i].categoryMid)
      //       .classList.remove("active");
      //   }
      //   this.privBoardIdList = [];
      // } else if (param === "CFRC") {
      //   for (let i = 0; i < this.cfrcList.length; i++) {
      //     document
      //       .getElementById("cfrcList_" + this.cfrcList[i].categoryMid)
      //       .classList.remove("active");
      //     console.log(this.cfrcList[i].categoryMid);
      //   }
      //   this.cfrcBoardIdList = [];
      // }
      this.categoryIdList = [];
    },
    categoryReset() {
      this.categoryIdList = [];
      this.proBoard = [];
      this.boardIdList = [];
    },
    boardReset() {
      this.boardIdList = [];
    },
    userReset() {
      this.targetUser = [];
      this.regUser = [];
    },

    categoryActive(param, param2) {
      let returnTF = false;
      for (let i = 0; i < this.categoryIdList.length; i++) {
        if (this.categoryIdList[i] === param) {
          returnTF = true;
        }
      }
      return returnTF;
    },
    boardActive(param) {
      let returnTF = false;
      for (let i = 0; i < this.boardIdList.length; i++) {
        if (this.boardIdList[i] === param) {
          returnTF = true;
        }
      }
      return returnTF;
    },

    initPrivGorupId() {
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/cogroup/cogroup/getMyGroupInfo";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          this.privGroupInfo = res.result;
          this.privGroupId = res.result.groupId;
          this.privGroupName = res.result.groupName;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/FilterBoxTodo.vue